import Component from './header2';

export default Component;

export {headerMeaningfulSelector} from './consts';
